import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { PainSection } from './sections/PainSection';
import { SolutionSection } from './sections/SolutionSection';
import { WhatYouGetSection } from './sections/WhatYouGetSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { UpsellSection } from './sections/UpsellSection';
import { PricingSection } from './sections/PricingSection';
import { GuaranteeSection } from './sections/GuaranteeSection';
import { FAQSection } from './sections/FAQSection';
export function SalesPage() {
  return <main className="min-h-screen bg-white font-sans selection:bg-[#D4A843] selection:text-[#0B1A2E]" data-id="element-1">
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <WhatYouGetSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <UpsellSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <FAQSection data-id="element-10" />
    </main>;
}